import type { MakeRequest } from "./types/MakeRequest";
import type { Options } from "./types/Options";

export const makePut =
  ({ makeRequest }: { makeRequest: MakeRequest }) =>
  (url: string, options: Options = {}) => {
    options.method = "put";

    return makeRequest(url, options);
  };
